import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule, MatToolbarModule, MatFormFieldModule, MatInputModule, MatCardModule, MatIconModule, MatProgressBarModule } from '@angular/material';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { routing } from './app-routing.module';

import { AppComponent } from './app.component';
import { OnlineSignPadComponent } from './online-sign-pad/online-sign-pad.component';

import { UserIdleModule } from 'angular-user-idle';


import { StoreModule } from '@ngrx/store';
import { reducer } from './statemanagement/reducer/parameter.reducer';
import { OnlinesignatureService } from './online-sign-pad/onlinesignature.service';
import { CommonModule } from '@angular/common';
import { EDictateComponent } from './e-dictate/e-dictate.component';
import { EDictateService } from './e-dictate/e-dictate.service';
import { ApplicationauthComponent } from './e-dictate/applicationauth/applicationauth.component';
import { PictureComponent } from './picture/picture.component';
import { PictureService } from './picture/picture.service';
import { AttachmentComponent } from './attachment/attachment.component';
import { AttachmentService } from './attachment/attachment.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { SignaturePadModule } from 'angular2-signaturepad';

/**
 * `App Module is the main entry point into Angular's bootstraping process
 */

@NgModule({
  declarations: [
        AppComponent,
        OnlineSignPadComponent,
        EDictateComponent,
        ApplicationauthComponent,
        PictureComponent,
        AttachmentComponent
  ],
    imports: [
        CommonModule,
      HttpClientModule,
      HttpModule,
      FormsModule,
      ReactiveFormsModule,
      BrowserModule,
      BrowserAnimationsModule,
      MatSidenavModule,
      MatToolbarModule,
        MatFormFieldModule,
        MatProgressBarModule,
        MatInputModule,
        MatIconModule,
        SignaturePadModule ,
      CoreModule.forRoot(),
      SharedModule,
      routing,
      UserIdleModule.forRoot({idle: 60, timeout: 15, ping:60}),
      MatCardModule,
      StoreModule.forRoot(
          {
            parameter: reducer  
          })
    ],
    providers: [OnlinesignatureService, EDictateService, PictureService, AttachmentService, NgxImageCompressService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./SignClient/app/app.module.ts